import { __rest } from "tslib";
import * as React from "react";
function SvgChevronRight(_a) {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 2048 2048", width: "1em", height: "1em", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "M605 3l1022 1021L605 2045l-90-90 930-931L515 93l90-90z" })));
}
export default SvgChevronRight;
